import { Component, OnInit, OnDestroy, HostListener, Input } from '@angular/core';
import { NavComponent } from 'app/shared/components/nav/nav.component';
import { Office } from 'app/core/models/office.model';
import { UserPresenceService } from 'app/core/services/user-presence.service';
const userPresenceKey = 'office';

@Component({
  selector: 'app-office-nav',
  templateUrl: './office-nav.component.html',
  styleUrls: ['./office-nav.component.scss'],
})
export class OfficeNavComponent extends NavComponent implements OnInit, OnDestroy {
  @Input() office: Office;

  constructor(
    private userPresenceService: UserPresenceService
  ) { super(); }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(): void {
    this.leaveAndUnsubscribe();
  }

  ngOnInit() {
    this.subscribeAndJoin();
  }

  ngOnDestroy(): void {
    this.leaveAndUnsubscribe();
  }

  private subscribeAndJoin() {
    this.userPresenceService.subscribeAndJoin(userPresenceKey, this.office.id);
  }

  private leaveAndUnsubscribe() {
    this.userPresenceService.leaveAndUnsubscribe(userPresenceKey, this.office.id);
  }
}
